var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, MailOutline as InviteIcon, Settings as ManageIcon, Groups as TeamsIcon, } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, Divider, IconButton, Stack, Typography, } from "@mui/material";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { TeamAvatar } from "../teams/TeamAvatar";
export var LeagueTeamsCard = function (_a) {
    var teams = _a.teams, leagueId = _a.leagueId, _b = _a.canModify, canModify = _b === void 0 ? false : _b, _c = _a.linkable, linkable = _c === void 0 ? true : _c;
    var maxTeamsToShow = 6;
    var showViewAllLink = teams.length > maxTeamsToShow;
    var teamsToDisplay = __spreadArray([], __read(teams), false).sort(function (a, b) { return a.team.name.localeCompare(b.team.name); })
        .slice(0, maxTeamsToShow);
    return (_jsx(Card, { children: _jsxs(CardContent, { children: [_jsxs(Box, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        mb: 2,
                    }, children: [_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 1 }, children: [_jsx(Typography, { variant: "h6", sx: { fontWeight: 600 }, children: "Teams" }), teams.length > 0 && (_jsx(Chip, { label: teams.length, size: "small", sx: {
                                        backgroundColor: "rgba(25, 118, 210, 0.1)",
                                        color: "primary.main",
                                        fontWeight: 600,
                                        minWidth: 24,
                                    } }))] }), canModify && (_jsxs(Stack, { direction: "row", spacing: 0.5, children: [_jsx(IconButton, { role: "button", component: Link, to: "/leagues/".concat(leagueId, "/invitations/"), size: "small", title: "Invite team", sx: {
                                        color: "primary.main",
                                        "&:hover": {
                                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                                            transform: "scale(1.05)",
                                        },
                                        transition: "all 0.2s ease",
                                    }, children: _jsx(InviteIcon, {}) }), _jsx(IconButton, { role: "button", component: Link, to: "/leagues/".concat(leagueId, "/teams/manage/"), size: "small", title: "Manage teams", sx: {
                                        color: "text.secondary",
                                        "&:hover": {
                                            backgroundColor: "rgba(0, 0, 0, 0.04)",
                                            transform: "scale(1.05)",
                                        },
                                        transition: "all 0.2s ease",
                                    }, children: _jsx(ManageIcon, {}) }), _jsx(IconButton, { role: "button", component: Link, to: "/leagues/".concat(leagueId, "/teams/add/"), size: "small", title: "Add teams", sx: {
                                        color: "primary.main",
                                        "&:hover": {
                                            backgroundColor: "rgba(25, 118, 210, 0.1)",
                                            transform: "scale(1.05)",
                                        },
                                        transition: "all 0.2s ease",
                                    }, children: _jsx(AddIcon, {}) })] }))] }), _jsx(Divider, { sx: { mb: 2 } }), _jsx(Stack, { spacing: 0, children: teams.length > 0 ? (teamsToDisplay.map(function (membership, index) {
                        var content = (_jsx(Box, { sx: __assign(__assign({ p: 2.5, display: "flex", alignItems: "center", justifyContent: "space-between" }, (linkable && {
                                "&:hover": {
                                    backgroundColor: "#f8f9ff",
                                    transform: "translateX(2px)",
                                },
                            })), { transition: "all 0.2s ease", borderBottom: index < teamsToDisplay.length - 1
                                    ? "1px solid rgba(0,0,0,0.08)"
                                    : "none" }), children: _jsxs(Box, { sx: { display: "flex", alignItems: "center" }, children: [_jsx(TeamAvatar, { team: membership.team }), _jsxs(Box, { sx: { ml: 2 }, children: [_jsx(Typography, { variant: "body1", sx: { fontWeight: 600, mb: 0.5 }, children: membership.team.name }), membership.team.nickname && (_jsx(Typography, { "test-id": "nickname", variant: "caption", sx: {
                                                    color: "text.secondary",
                                                    fontStyle: "italic",
                                                    display: "block",
                                                }, children: membership.team.nickname })), _jsxs(Typography, { variant: "caption", sx: { color: "text.secondary", display: "block" }, children: ["Joined ", format(new Date(membership.dateJoined), "yyyy")] })] })] }) }, linkable ? undefined : membership.id));
                        return linkable ? (_jsx(Link, { to: "/teams/".concat(membership.team.id, "/"), style: { textDecoration: "none", color: "inherit" }, children: content }, membership.id)) : (content);
                    })) : (_jsxs(Box, { sx: { p: 4, textAlign: "center" }, children: [_jsx(Avatar, { sx: {
                                    width: 56,
                                    height: 56,
                                    backgroundColor: "rgba(25, 118, 210, 0.1)",
                                    color: "primary.main",
                                    mx: "auto",
                                    mb: 2,
                                }, children: _jsx(TeamsIcon, { sx: { fontSize: 28 } }) }), _jsx(Typography, { variant: "h6", color: "text.secondary", sx: { mb: 1 }, children: "No teams yet" }), _jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: "Add teams to get started" }), canModify && (_jsx(IconButton, { role: "button", component: Link, to: "/leagues/".concat(leagueId, "/teams/add/"), sx: {
                                    backgroundColor: "primary.main",
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "primary.dark",
                                        transform: "scale(1.05)",
                                    },
                                    transition: "all 0.2s ease",
                                }, children: _jsx(AddIcon, {}) }))] })) }), linkable && showViewAllLink && (_jsx(Box, { sx: {
                        p: 2,
                        textAlign: "center",
                        backgroundColor: "rgba(25, 118, 210, 0.02)",
                        borderTop: "1px solid rgba(0,0,0,0.08)",
                        mt: 1,
                    }, children: _jsx(Link, { to: "/leagues/".concat(leagueId, "/teams/"), style: { textDecoration: "none" }, children: _jsxs(Typography, { variant: "body2", sx: {
                                color: "primary.main",
                                fontWeight: 500,
                                "&:hover": {
                                    textDecoration: "underline",
                                },
                            }, children: ["View all ", teams.length, " teams \u2192"] }) }) }))] }) }));
};
